/**
 * @generated SignedSource<<6cfad544b1efb06291d5fcad35698373>>
 * @relayHash e7d986c9db7dfd3a42ef96015dfa9ca2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fec66635336d0d806dec6091a699738ecb8314e2e4abfaa9b3a98e3d7d6f4de4

import type { ConcreteRequest } from 'relay-runtime';
export type preloadPendingRequestExistsQuery$variables = {
  accessRequestedAaid: string;
  cloudId: string;
  contentId: string;
};
export type preloadPendingRequestExistsQuery$data = {
  readonly confluence_pendingRequestExists: {
    readonly isPendingAccessRequestExists: boolean | null;
  } | null;
};
export type preloadPendingRequestExistsQuery = {
  response: preloadPendingRequestExistsQuery$data;
  variables: preloadPendingRequestExistsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessRequestedAaid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accessRequestedAaid",
        "variableName": "accessRequestedAaid"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ConfluencePendingAccessRequest",
    "kind": "LinkedField",
    "name": "confluence_pendingRequestExists",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isPendingAccessRequestExists"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadPendingRequestExistsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadPendingRequestExistsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e7d986c9db7dfd3a42ef96015dfa9ca2",
    "id": "fec66635336d0d806dec6091a699738ecb8314e2e4abfaa9b3a98e3d7d6f4de4",
    "metadata": {},
    "name": "preloadPendingRequestExistsQuery",
    "operationKind": "query",
    "text": "query preloadPendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
  }
};
})();

(node as any).hash = "cdc10e1c835031af29b6e3680fe359e2";

export default node;
